import { Announcement } from "../../interface/device.details";

export const toDateOnly = (d: Date) =>
    new Date(d.getFullYear(), d.getMonth(), d.getDate());

export const parseDate = (v: any) => (v instanceof Date ? v : new Date(v));

export const weekdayKey = (date = new Date()) =>
    ["sun", "mon", "tue", "wed", "thu", "fri", "sat"][date.getDay()];

export const timeToMin = (t: string) => {
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
};

export const isWithinTime = (start: string, end: string, now = new Date()) => {
    const nowMin = now.getHours() * 60 + now.getMinutes();
    return nowMin >= timeToMin(start) && nowMin <= timeToMin(end);
};

export const isAnnouncementActive = (a?: Announcement | null, now = new Date()) => {
    if (!a || !a.messageContent?.lines?.length) return false;

    const startAt = parseDate(a.startAt);
    const endAt = parseDate(a.endAt);

    const today = toDateOnly(now);
    if (today < toDateOnly(startAt) || today > toDateOnly(endAt)) return false;

    if (a.recurring) {
        const rule = a.weekdays.find((w) => w.day === weekdayKey(now));
        if (!rule) return false;
        return isWithinTime(rule.startTime, rule.endTime, now);
    }

    return isWithinTime(a.startTime, a.endTime, now);
};
